import React, { Component } from 'react';
import PurchaseList from '../Userprofile/Purchaselist';
import Menu from '../Sidepanel/Leftmenu';
import { getFirestore, collection, doc, getDoc } from 'firebase/firestore';
import '../../index.css';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ShopItem from '../Shop/Shopitem';
import Completion from '../Shop/Completion';
import Kart from '../Shop/ShopCart';
import SupportForm from '../Support/Supportform';
import ModernLanding from './ModernLanding';
import {
  GoogleAuthProvider,
  EmailAuthProvider,
  getAuth,
  signInWithPopup,
} from 'firebase/auth';

const db = getFirestore();
const firebaseUiTranslations = new Map([
  ['Sign in with email', 'Mit E-Mail anmelden'],
  ['Email', 'E-Mail-Adresse'],
  ['Next', 'Weiter'],
  ['Sign in', 'Anmelden'],
  ['Create account', 'Konto erstellen'],
  ['Create an account', 'Konto erstellen'],
  ['Name', 'Name'],
  ['Password', 'Passwort'],
  ['Confirm password', 'Passwort bestätigen'],
  ['Enter your password', 'Passwort eingeben'],
  ['Forgot password?', 'Passwort vergessen?'],
  ['Trouble signing in?', 'Probleme bei der Anmeldung?'],
  ['Reset password', 'Passwort zurücksetzen'],
  ['Send', 'Senden'],
  ['Continue', 'Weiter'],
  ['Back', 'Zurück'],
  ['Save', 'Speichern'],
  ['Check your email', 'Prüfe deine E-Mails'],
  ['Please enter a valid email address', 'Bitte gib eine gültige E-Mail-Adresse ein'],
  ['Password must be at least 6 characters', 'Das Passwort muss mindestens 6 Zeichen lang sein'],
]);

export default class ConnectUI extends Component {
  state = {
    isSignedIn: false,
    totalNumber: 0,
    examNumber: 0,
    themesNumber: 0,
    isGoogleLoading: false,
    authError: '',
  };

  async fetchData() {
    const docRef = doc(collection(db, 'Aufgaben'), 'Insgesamt');
    const snapshot = await getDoc(docRef);
    return snapshot.data();
  }

  componentDidMount() {
    this.fetchData()
      .then((result) => {
        if (!result) return;
        this.setState({
          totalNumber: result.Total,
          examNumber: result.Exam,
          themesNumber: result.Themes,
        });
      })
      .catch((error) => {
        console.error('Error fetching document: ', error);
      });

    this.unregisterAuthObserver = getAuth().onAuthStateChanged((user) =>
      this.setState({ isSignedIn: Boolean(user) })
    );

    this.startFirebaseUi();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isSignedIn && !this.state.isSignedIn) {
      this.startFirebaseUi();
    }
  }

  componentWillUnmount() {
    if (this.unregisterAuthObserver) {
      this.unregisterAuthObserver();
    }
    if (this.firebaseUiObserver) {
      this.firebaseUiObserver.disconnect();
    }
  }

  localizeFirebaseUi = () => {
    const container = document.getElementById('firebaseui-auth-container');
    if (!container) return;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      const sourceText = node.nodeValue.trim();
      const translation = firebaseUiTranslations.get(sourceText);
      if (translation) {
        node.nodeValue = node.nodeValue.replace(sourceText, translation);
      }
      node = walker.nextNode();
    }

    container.querySelectorAll('input').forEach((input) => {
      const translatedPlaceholder = firebaseUiTranslations.get(input.placeholder);
      if (translatedPlaceholder) input.placeholder = translatedPlaceholder;
    });
  };

  startFirebaseUi = () => {
    if (!document.getElementById('firebaseui-auth-container')) return;

    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(getAuth());
    }

    ui.start('#firebaseui-auth-container', this.uiConfig);
  };

  uiConfig = {
    signInSuccessUrl: '/shop',
    signInOptions: [
      {
        provider: EmailAuthProvider.PROVIDER_ID,
        fullLabel: 'Mit E-Mail anmelden',
      },
    ],
    privacyPolicyUrl: function () {
      window.location.assign('/datenschutz/');
    },
    tosUrl: function () {
      window.location.assign(
        'https://firebasestorage.googleapis.com/v0/b/ziel-studienkolleg.appspot.com/o/Documents%2FNutzungsvertrag_der_Plattform.pdf?alt=media&token=9e68fe40-f9b0-4e4e-9935-6ee5e7b58102'
      );
    },
    callbacks: {
      signInSuccessWithAuthResult: () => false,
      uiShown: () => {
        this.localizeFirebaseUi();
        const container = document.getElementById('firebaseui-auth-container');
        if (!container) return;
        if (this.firebaseUiObserver) this.firebaseUiObserver.disconnect();
        this.firebaseUiObserver = new MutationObserver(this.localizeFirebaseUi);
        this.firebaseUiObserver.observe(container, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      },
    },
  };

  signInWithGoogle = () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    this.setState({ isGoogleLoading: true, authError: '' });
    signInWithPopup(auth, provider)
      .then(() => {
        this.setState({ isSignedIn: true });
      })
      .catch((error) => {
        console.error('Error during sign-in:', error);
        this.setState({
          authError: 'Die Anmeldung mit Google ist fehlgeschlagen. Bitte versuche es erneut.',
        });
      })
      .finally(() => {
        this.setState({ isGoogleLoading: false });
      });
  };

  Logout = () => {
    return getAuth().signOut().then(() => {
      this.setState({ isSignedIn: false });
    });
  };

  render() {
    const {
      isSignedIn,
      totalNumber,
      examNumber,
      themesNumber,
      isGoogleLoading,
      authError,
    } = this.state;

    if (!isSignedIn) {
      return (
        <ModernLanding
          totalNumber={totalNumber}
          examNumber={examNumber}
          themesNumber={themesNumber}
          isGoogleLoading={isGoogleLoading}
          authError={authError}
          onGoogleSignIn={this.signInWithGoogle}
        />
      );
    }

    const currentUser = getAuth().currentUser;

    return (
      <div id="main-div-block" className="app-shell">
        <div className="app-shell__glow app-shell__glow--blue" />
        <div className="app-shell__glow app-shell__glow--yellow" />
        <div className="app-main">
          <BrowserRouter>
            <div className="app-layout">
              <Menu
                imageUrl={currentUser.photoURL}
                displayName={currentUser.displayName}
                userEmail={currentUser.email}
                auth={this.Logout}
              />
              <main className="app-content">
                <Routes>
                  <Route path="/list" element={<PurchaseList user={currentUser} />} />
                  <Route path="/comp" element={<Completion />} />
                  <Route path="/shop" element={<ShopItem />} />
                  <Route path="/cart" element={<Kart />} />
                  <Route path="/support" element={<SupportForm />} />
                  <Route path="/" element={<Navigate to="/shop" replace />} />
                </Routes>
              </main>
            </div>
          </BrowserRouter>
        </div>
      </div>
    );
  }
}
